import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SharedService {
  storeId: object = {};
  // profileImageData: string | null = null;
  private profileImageSource = new BehaviorSubject<string | null>(null);
  profileImage$ = this.profileImageSource.asObservable();

  constructor(private router: Router) { }
  setDeviceData(val: object) {
    this.storeId = val;
  }
  getDeviceData() {
    return this.storeId;
  }

  updateProfileImage(imageSrc: string | null) {
    // console.log("imageSrcccccccccccccccc",imageSrc)
    this.profileImageSource.next(imageSrc);
  }


  // setProfileImageData(imageData: string | null) {
  //   this.profileImageData = imageData;
  // }
  // getProfileImageData() {
  //   return this.profileImageData;
  // }


  generatePass(passwordLength = 16): string {
    const lowerCaseLetters = 'abcdefghijklmnopqrstuvwxyz';
    const upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()_-,.';

    const characters = lowerCaseLetters + upperCaseLetters + numbers + symbols;
    characters.split('');

    const generatedPassword = [];

    for (let i = 0; i < passwordLength; i += 1) {
      const max = characters.length;
      const ran = Math.random();
      const idx = Math.floor(ran * (max + 1));
      generatedPassword.push(characters[idx]);
    }

    return generatedPassword.join('');
  }

  getActionItem(actionName: string) {
    const list = JSON.parse(localStorage.getItem('aclDataForAdhd') as string);
    // console.log('list: ', list);
    const subList = list.flatMap((item: any) => item.submenu);
    const url = this.router.url.trim();
    let subUrl = url.substring(url.indexOf('/', 1));
    if (subUrl.includes('?')) {
      subUrl = subUrl.split('?')[0];
    }
    // console.log('getActionItem', 'subUrl: ', subUrl);
    const subMenu = subList.find((sub: any) => sub.url === subUrl);
    // console.log('getActionItem', 'subMenu: ', subMenu);
    const hasAccess = subMenu?.action.find(
      (act: any) => act.name === actionName
    );
    if (hasAccess) {
      return true;
    }
    return false;
  }

  getActionItemBySubmenu(submenuName: string, actionName: string) {
    const list = JSON.parse(localStorage.getItem('aclDataForAdhd') as string);
    // console.log('getActionItemBySubmenu', 'list: ', list);
    const subList = list.flatMap((item: any) => item.submenu);
    const subMenu = subList.find((sub: any) => sub.name === submenuName);
    // console.log('getActionItemBySubmenu', 'subMenu: ', subMenu);
    const hasAccess = subMenu?.action.find(
      (act: any) => act.name === actionName
    );
    if (hasAccess) {
      return true;
    }
    return false;
  }

  getMonths() {
    return new Array(
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec'
    );
  }


  DATE_FORMAT: string = 'DD/MM/YYYY';

  // format Date
  formatDate(date: Date) {
    // DD/MM/YYYY using moment

    try {
      const m = moment(date);
      if (m.isValid()) {
        return m.format(this.DATE_FORMAT);
      }
      else {
        // console.log('invalid date', { date, m });
        return '';
      }
    }
    catch (e) {
      // console.log('error in formatting date', e);
      return '';
    }

  }



}
